import { useEffect, useState } from 'react'
import { useMaterialTopTutors } from '../../../modules/apis/student/tutors/recommend/queries'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { useOnclickHeartTutor } from '../../../modules/hooks/common/useOnclickHeartTutor'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_material } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { TUTOR_TYPE } from '../../../modules/vars'
import TutorCard from '../../common/TutorCard'
import TripleSlider from '../../common/slider/TripleSlider'
import { TUTOR_PROFILE_TAB } from '../../student/new-portal/tutors/TutorBody'

const MaterialTutorSection = () => {
  const router = useAppRouter()
  const { t } = useTranslation()
  const materialId = router.query.materialId as string

  const { data, isLoading } = useMaterialTopTutors(materialId)
  const [tutors, setTutors] = useState([])
  const getFullUrl = useReturnFullUrl()

  const onClickHeartTutor = useOnclickHeartTutor({
    isList: true,
    tutorItems: tutors,
    setTutorItems: setTutors,
  })

  const onClickHeartTutorTab = async (e: React.MouseEvent, tutor, type, showToast = true) => {
    onClickHeartTutor(e, tutor, type, showToast)
  }

  useEffect(() => {
    if (data && !isLoading) {
      const temp = data.tutors.map((tutor) => {
        return {
          ...tutor,
          primary_keyword: tutor.keywords[0],
        }
      })

      setTutors(temp)
    }
  }, [data, isLoading])

  if (!data || isLoading) return null
  if (data && data.length == 0) return null
  return (
    tutors?.length > 0 && (
      <div className="mb-[40px] w-full">
        <div className="border-t-1 mb-[24px] h-[8px] w-full border-gray-100 bg-gray-50" />
        <div className="Title1-20Bd mt-[24px] mb-[12px]">{t(n_material.tutor)}</div>
        <div className="hidden w-full flex-row sm:flex" style={{ width: '668px' }}>
          <TripleSlider>
            {tutors?.map((tutor) => {
              return (
                <TutorCard
                  className="mr-[16px]"
                  vertical
                  isRecommend={true}
                  key={tutor.id + `_material`}
                  handleAvatarClick={(e) =>
                    router.push(urls.student.newPortal.tutors.detail.as(tutor.id), {
                      appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
                      appSendData: {
                        url: getFullUrl(urls.webview.tutors.detail.as(tutor.id, TUTOR_PROFILE_TAB.SUMMARY)),
                      },
                    })
                  }
                  onClickHeart={(e) => onClickHeartTutorTab(e, tutor, TUTOR_TYPE.MY_TUTOR)}
                  tutor={tutor}
                />
              )
            })}
          </TripleSlider>
        </div>
        <div className="flex w-full flex-col sm:hidden gap-y-[12px]">
          {tutors?.map((tutor) => {
            return (
              <TutorCard
                isRecommend={true}
                key={tutor.id}
                handleAvatarClick={(e) =>
                  router.push(urls.student.newPortal.tutors.detail.as(tutor.id), {
                    appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
                    appSendData: {
                      url: getFullUrl(urls.webview.tutors.detail.as(tutor.id, TUTOR_PROFILE_TAB.SUMMARY)),
                    },
                  })
                }
                onClickHeart={(e) => onClickHeartTutorTab(e, tutor, TUTOR_TYPE.MY_TUTOR)}
                tutor={tutor}
              />
            )
          })}
        </div>
      </div>
    )
  )
}

export default MaterialTutorSection
